import { createContext, useContext } from 'react';

import type { EmbedSearchWidgetApiMetadata } from '#/modules/embedSearchWidget/api/types/EmbedSearchWidgetApiMetadata';

export const EmbedSearchWidgetContext =
  createContext<EmbedSearchWidgetApiMetadata | null>(null);

export function useEmbedSearchWidget(): {
  embedSearchWidget: EmbedSearchWidgetApiMetadata | null;
} {
  const embedSearchWidget = useContext(EmbedSearchWidgetContext);
  return { embedSearchWidget };
}
